import { ItemId, ItemPermissions } from './items';

export enum ProductCodes {
  PayAsYouGo = 'subscription-pay-as-you-go',
  ProYear12videos = 'subscription-pro-1year-12videos',
  ProYear24videos = 'subscription-pro-1year-24videos',
  TeleprompterMonthly = 'subscription-teleprompter-monthly',
  TeleprompterAnnual = 'subscription-teleprompter-yearly',
}
export type SubscriptionLevel = 'pay_as_you' | 'pro' | 'teleprompter';

export type Product = {
  product_code: ProductCodes;
  title: string;
  subscription_level: SubscriptionLevel;
  billing_period_count: number;
  cost_per_unit: number;
  video_units: number;
  max_period_available_duration: number;
  is_subscription?: boolean;
  display_order: number;
  id: ItemId;
  permissions: ItemPermissions;
};
